import { render, staticRenderFns } from "./deviceProfile.vue?vue&type=template&id=89844c4e"
import script from "./deviceProfile.vue?vue&type=script&lang=js"
export * from "./deviceProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports